import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';
import { useStyles } from './style';
const WrapBoxDiv = styled.div.withConfig({
  displayName: "VisitAttributeCheckboxes__WrapBoxDiv",
  componentId: "sc-1pire97-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;"]);
export const VisitAttributeCheckboxes = ({
  attributes,
  handleAttributeChange
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(WrapBoxDiv, null, attributes.map((visitAttribute, index) => /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: visitAttribute.isSelected,
      name: visitAttribute.name,
      disabled: !visitAttribute.selectable || !visitAttribute.uiavailable,
      onChange: (event, checked) => {
        handleAttributeChange(visitAttribute, checked);
      }
    }),
    label: visitAttribute.name,
    key: `visitAttribute-${visitAttribute.id}`,
    classes: {
      label: classes.radioLabel,
      root: classes.radioLabel
    }
  })));
};